/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const styles = cssMap({
	additionalSpacing: {
		paddingBlock: token('space.050'),
	},

	message: {
		color: token('color.text'),
	},
});

export const SuccessView = (): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.additionalSpacing}>
			<Inline space="space.100" alignBlock="center" xcss={styles.message}>
				<StatusSuccessIcon
					color={token('color.icon.success')}
					spacing="spacious"
					size="medium"
					label=""
				/>
				{formatMessage(messages.successMessage)}
			</Inline>
		</Box>
	);
};
